export default __webpack_public_path__ + "21a78fbcc76fcdcf0503211ac0f45866.svg";